import * as $ from "jquery";
import * as validate from "../../lib/validate.min.js";
import TranslationsService from "../services/translationsService";
declare global {
	interface Window {
		dataLayer:any;
	}
}
/**
 * Setting the email pattern according to the RegExp found at http://emailregex.com/
 * @type {RegExp}
 */
validate.validators.email.PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
let $MMERGE2 = $('[name="MMERGE2"]');
let $MMERGE3 = $('[name="MMERGE3"]');
let $EMAIL = $('[name="EMAIL"]');
let $subscribe = $('[name="subscribe"]');
let today = new Date;
let $currentMonth = $('[name="MMERGE1[month]"]');
let $currentDay = $('[name="MMERGE1[day]"]');
let $currentYear = $('[name="MMERGE1[year]"]');
let $Promotions = $('[name = "group[4567][8192]"]');
let $Product = $('[name="group[4567][16384]"]');
let $Innovation = $('[name="group[4567][32768]"]');
let $Ideas = $('[name="group[4567][262144]"]');
let $TradeShow = $('[name="group[4567][65536]"]');
let $Single = $('[name="group[4567][524288]"]');
let $Multiple = $('[name="group[4567][1048576]"]');
let $Showroom = $('[name="group[4567][2097152]"]');
let $Rehab = $('[name="group[4567][4194304]"]');
let $Remodeler = $('[name="group[4567][8388608]"]');
let $Plumber = $('[name="group[4567][16777216]"]');
let $Designer = $('[name="group[4567][33554432]"]');
let $Architect = $('[name="group[4567][67108864]"]');
let $Other = $('[name="group[4567][134217728]"]');

let $ContentError = $('[name="divContentError"]');
let $PRIVACY = $('[name="PRIVACY"]');
let haveContent:boolean = true;
const translationsService = TranslationsService.getInstance();
translationsService.addTranslations('email-signup-translations');

let constraints = {
	MMERGE2: {
		presence: {
			allowEmpty: false,
			message: '^' + translationsService.translate('FormValidationErrors.FirstNameRequired')
		}
	},
	MMERGE3: {
		presence: {
			allowEmpty: false,
			message: '^' + translationsService.translate('FormValidationErrors.LastNameRequired')
		}
	},
	EMAIL: {
		email: {
			message: '^' + translationsService.translate('FormValidationErrors.EmailInvalid')
		}
	}
};
let checkContentPreferences = function()
{
	if($Promotions.prop('checked') || $Product.prop('checked') || $Ideas.prop('checked') || $Innovation.prop('checked') 
	|| $TradeShow.prop('checked') || $Single.prop('checked') || $Multiple.prop('checked') || $Showroom.prop('checked') || $Remodeler.prop('checked')
	|| $Plumber.prop('checked') || $Rehab.prop('checked')|| $Designer.prop('checked')|| $Architect.prop('checked')|| $Other.prop('checked'))
	{	
	   haveContent = true;
	   $ContentError.attr("style", "display:none");	  
	}
	else
	{	
		haveContent = false;
		$ContentError.attr("style", "display:block");
	}		
}
let emailSignupValidate = function () {		
	let result = validate({
		MMERGE2: $MMERGE2.val(),
		MMERGE3: $MMERGE3.val(),
		EMAIL: $EMAIL.val()		
	}, constraints);	
	$('.has-error').removeClass('has-error');
	$('.form-error-message').remove();
	// if all fields valid check if content preferences are checked, only for international innovations is defaulted
	let baseHostName = window.location.hostname;
	if (baseHostName.toLowerCase().indexOf('international') != -1)
	{
      $Innovation.prop('checked', 'checked');
	}
	checkContentPreferences();		
	if (result) {
		$subscribe.attr('disabled', true);
		$.each(result, function (key, val) {
			let $element = $(`[name="${key}"]`);
			let error = `<div class="form-error-message">${val[0]}</div>`;

			if ($element.hasClass('dirty')) {
				if ($element.is(':checkbox')) {
					$element.parents('.form-group').addClass('has-error').append(error);
				} else {
					$element.parent().addClass('has-error');
					if ($element.siblings('.input-group-btn').length) {
						$element.parent().after(error);
					} else {
						$element.after(error);
					}
				}
			}
		});			
	} else {
		if(haveContent)
		{
		  $subscribe.removeAttr('disabled');
		}
		else
		{
		  $subscribe.attr('disabled', true);
		}
	}	
};

let trackFormSubmission = function () {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({'event' : 'email_sign_up'});
};

let setCurrentDate = function () {
	$currentMonth.val(("0" + (today.getMonth() + 1)).slice(-2));
	$currentYear.val(today.getFullYear());
	$currentDay.val(("0" + today.getDate()).slice(-2));
	$PRIVACY.prop('checked', 'checked');
};

let validateField = function () {
	$(this).addClass('dirty');
	emailSignupValidate();
};

let emailSignupAddEventListeners = function () {
	$MMERGE2.on('blur change', validateField);
	$MMERGE3.on('blur change', validateField);
	$EMAIL.on('blur change', validateField);
	$Promotions.on('blur change', emailSignupValidate);
	$Product.on('blur change', emailSignupValidate);
	$Ideas.on('blur change', emailSignupValidate);
	$TradeShow.on('blur change', emailSignupValidate);
	$Innovation.on('blur change', emailSignupValidate);	
	$Single.on('blur change', emailSignupValidate);	
	$Multiple.on('blur change', emailSignupValidate);	
	$Showroom.on('blur change', emailSignupValidate);	
	$Remodeler.on('blur change', emailSignupValidate);	
	$Plumber.on('blur change', emailSignupValidate);	
	$Rehab.on('blur change', emailSignupValidate);	
	$Designer.on('blur change', emailSignupValidate);	
	$Architect.on('blur change', emailSignupValidate);	
	$Other.on('blur change', emailSignupValidate);			
	$('#emailSignupForm').on('submit', trackFormSubmission);
};

export function init() {
	emailSignupAddEventListeners();
	setCurrentDate();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/emailSignup.ts